// Must run before ReactDOM renders: protects React's DOM operations from
// Chrome/Google page translation rewriting text nodes (white-page crash).
import './composer/tools/domTranslationGuard.js';

import React from 'react';
// import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import './index.css';
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import { ThemeProvider, createTheme } from '@mui/material/styles';

// Mantine (MUI -> Mantine migration, Lane A: @mantine/emotion).
// MantineProvider is mounted OUTSIDE the MUI ThemeProvider so both frameworks
// coexist during the incremental migration. @mantine/emotion lets Mantine reuse
// the Emotion engine MUI already ships, so sx/styles/createStyles keep working.
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { emotionTransform, MantineEmotionProvider } from '@mantine/emotion';
import { mantineTheme } from './composer/theme/brandTheme.js';

import RootPage from "./composer/pages/RootPage.jsx";
import SharedSubmissionPage from "./composer/pages/SharedSubmissionPage.jsx";
import AppErrorBoundary from "./composer/views/AppErrorBoundary.jsx";
import './composer/css/styles.css';

// Theme configuration moved from RootPage.jsx to here
const theme = createTheme({
  palette: {
    primary: {
      main: '#ad1179',
    },
    secondary: {
      main: '#b8a3bf',
    },
    halfToneColour: {
      main: '#999999',
    },  
    mutedColour: {
      main: '#cccccc',
    },  
  },
  typography: {
    body1: {
      fontWeight: 300,
      fontSize: '1rem',
      color: 'rgba(0, 0, 0, 0.7)',
    },
    body2: {
      fontWeight: 500,
      fontSize: '1rem',
      color: 'rgba(0, 0, 0, 0.7)',
    },
    body3: {
      fontWeight: 'bold',
      fontSize: '0.5rem',
      color: 'rgba(0, 0, 0, 0.7)',
    },
    fontFamily: [
      "CeraPro",
      "Noto Sans TC",
      "Roboto",
      '"Helvetica Neue"',
    ].join(','),
  },
  components: {
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          height: '48px',
          padding: '0 24px',
          display: 'flex',
          alignItems: 'center',
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          height: '32px',
          minHeight: '32px',
          display: 'flex',
          alignItems: 'center',
          padding: '0 24px 0 8px',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          height: '32px',
          padding: '0 14px',
        },
      },
    },
  },
});

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <MantineProvider theme={mantineTheme} stylesTransform={emotionTransform}>
    <MantineEmotionProvider>
      <Notifications position="bottom-center" zIndex={3000} autoClose={6000} />
      <ThemeProvider theme={theme}>
        <AppErrorBoundary>
          <Router>
            <Switch>
              <Route path="/share/:shareToken" component={SharedSubmissionPage} />
              <Route path="/" render={(props) => <RootPage {...props} parent={this} />} />
            </Switch>
          </Router>
        </AppErrorBoundary>
      </ThemeProvider>
    </MantineEmotionProvider>
  </MantineProvider>
);
